import { Action, createReducer, on } from '@ngrx/store';
import { initialState, IStartPageInfoState } from './system-info.state';
import * as SystemInfoActions from './system-info.actions';

const systemInfoReducerInternal = createReducer(
  initialState,
  
  on(SystemInfoActions.loadSystemInfo, (state) => ({
    ...state
  })),
  
  on(SystemInfoActions.loadSystemInfoSuccess, (state, { systemInfo }) => ({
    ...state,
    systemMessageMarkdown: systemInfo.systemMessageMarkdown,
    wartungsfenster: systemInfo.wartungsfenster
  })),
  
  on(SystemInfoActions.loadSystemInfoError, (state) => ({
    ...state,
    systemMessageMarkdown: null,
    wartungsfenster: []
  }))
);

export function systemInfoReducer(state: IStartPageInfoState | undefined, action: Action): IStartPageInfoState {
  return systemInfoReducerInternal(state, action);
}
